import React from 'react';
import { Skel, SkeletonRegion, SkeletonStats, SkeletonList } from './PageState';

/**
 * Esqueleto da casca do app (pílula de ferramentas + cabeçalho + conteúdo).
 * Aparece enquanto a sessão/organização carrega, no lugar do spinner solto.
 */
export function ShellSkeleton() {
  return (
    <div className="dashboard-layout">
      <div className="sidebar" aria-hidden>
        <Skel className="sk-circle" w={40} h={40} />
        <div className="sidebar-nav" style={{ alignItems: 'center' }}>
          {Array.from({ length: 5 }).map((_, i) => (
            <Skel key={i} className="" w={40} h={40} style={{ borderRadius: 14 }} />
          ))}
        </div>
      </div>
      <main className="main-content" aria-label="Carregando">
        <header className="desktop-header" aria-hidden>
          <Skel w={140} h={14} />
          <div className="desktop-header-right">
            <Skel className="sk-circle" w={32} h={32} />
            <Skel className="sk-circle" w={32} h={32} />
          </div>
        </header>
        <div className="content-wrapper">
          <SkeletonRegion label="Carregando sua conta…">
            <div className="page-header">
              <div className="sk-stack" style={{ width: '100%' }}>
                <Skel w={200} h={30} />
                <Skel w={300} h={14} />
              </div>
            </div>
            <SkeletonStats count={3} />
            <div className="sk-panel">
              <SkeletonList rows={4} />
            </div>
          </SkeletonRegion>
        </div>
      </main>
    </div>
  );
}

/** Esqueleto do cartão de login/registro, para a checagem inicial de sessão. */
export function AuthCardSkeleton() {
  return (
    <div className="auth-container">
      <div className="glass-card">
        <SkeletonRegion label="Carregando…">
          <div className="sk-stack" style={{ alignItems: 'center', marginBottom: '1.5rem' }}>
            <Skel className="sk-circle" w={56} h={56} />
            <Skel w="60%" h={26} />
            <Skel w="80%" h={14} />
          </div>
          <div className="sk-stack">
            <Skel h={46} style={{ borderRadius: 8 }} />
            <Skel h={46} style={{ borderRadius: 8 }} />
            <Skel h={46} style={{ borderRadius: 8 }} />
          </div>
        </SkeletonRegion>
      </div>
    </div>
  );
}
